import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold mb-2">Refund Policy</h1>
          <p className="text-gray-600 mb-8">Effective Date: {new Date().toLocaleDateString()}</p>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Refund Eligibility</h2>
              <p className="mb-2">We offer refunds under the following conditions:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li><strong>Defective Products:</strong> Items that arrive damaged or defective</li>
                <li><strong>Wrong Items:</strong> If you receive incorrect products</li>
                <li><strong>Non-Delivery:</strong> If your order doesn't arrive within the estimated timeframe</li>
                <li><strong>Quality Issues:</strong> Products that don't match the description</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Refund Timeframe</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li>Refund requests must be submitted within <strong>30 days</strong> of delivery</li>
                <li>Perishable items (Fruits & Drinks) must be reported within <strong>24 hours</strong> of delivery</li>
                <li>For baby products and clothing, refund window is <strong>14 days</strong> from delivery</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">3. How to Request a Refund</h2>
              <ol className="list-decimal ml-6 space-y-2">
                <li>Contact our customer service at <a href="mailto:support@dresspay.com" className="text-indigo-600 hover:underline">support@dresspay.com</a></li>
                <li>Provide your order confirmation code (5-digit code)</li>
                <li>Include photos of defective/incorrect items (if applicable)</li>
                <li>Explain the reason for your refund request</li>
              </ol>
              <p className="mt-3">Our team will review your request within <strong>2-3 business days</strong>.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Refund Processing</h2>
              <p className="mb-2">Once approved:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Refunds are processed within <strong>5-7 business days</strong></li>
                <li>Money will be returned to your original payment method</li>
                <li>Credit/Debit Card refunds: 5-10 business days</li>
                <li>Apple Pay/Cash App refunds: 3-5 business days</li>
                <li>Cryptocurrency refunds: 1-3 business days (to original wallet)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Non-Refundable Items</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li>Opened or used personal care items</li>
                <li>Perishable goods after 24 hours of delivery</li>
                <li>Digital products or gift cards</li>
                <li>Items marked as "Final Sale" or "Clearance"</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Partial Refunds</h2>
              <p>Partial refunds may be granted for:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Items with obvious signs of use</li>
                <li>Missing original packaging or accessories</li>
                <li>Items returned after the refund period</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Shipping Costs</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li>Original shipping fees are non-refundable (except for defective items)</li>
                <li>Return shipping costs are customer's responsibility unless the item is defective</li>
                <li>We provide prepaid return labels for defective/incorrect items</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Contact Us</h2>
              <p>For refund inquiries, contact us:</p>
              <ul className="list-none ml-0 mt-2 space-y-1">
                <li><strong>Email:</strong> <a href="mailto:support@dresspay.com" className="text-indigo-600 hover:underline">support@dresspay.com</a></li>
                <li><strong>Phone:</strong> <a href="tel:3464837337" className="text-indigo-600 hover:underline">346-483-7337</a></li>
                <li><strong>Hours:</strong> Monday - Friday, 9 AM - 6 PM EST</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;